import { consulta_de_alunos_com_reserva_de_vagas_web as consulta_web } from "./consulta-de-alunos-com-reserva-de-vagas-web";

const consulta_de_alunos_com_reserva_de_vagas_web = [consulta_web];

export { consulta_de_alunos_com_reserva_de_vagas_web };
